<template>
    <v-dialog v-model="show" max-width="753px" persistent>
        <div class="modal congrats-modal">
            <v-row class="congrats-row" style="margin: 0 auto;">
                <div class="icon-modal table-cell congrats-icon">
                    <v-layout class="align-center">
                        <v-flex>
                            <img :src="require('@/assets/img/hand.svg')" style="position: relative;top: -45px;" alt=""/>
                        </v-flex>
                    </v-layout>
                </div>
                <v-col class="table-cell modal-content col custom-o-position">
                    <div class="d-flex justify-space-between">
                        <h6 class="modal-title mb-5 congrats-title">Congratulations!</h6>
                    </div>

                    <p class="mb-0">
                        <b class="congrats-subtitle">Your account is now active</b>
                    </p>

                    <p class="mt-5 mb-1">
                        <span>Please download the Kiey on your mobile device</span>
                    </p>

                    <v-row class="store-buttons" style="position: relative; top: -4px;">
                        <div class="table-cell">
                            <a :href="this.$store.getters['Authenticate/getAppleStoreUrl']" target="_blank">
                                <img :src="require('@/assets/img/apple_store.svg')" alt=""/>
                            </a>
                        </div>
                        <div class="table-cell" style="position: relative;left: -2px;">
                            <a :href="this.$store.getters['Authenticate/getGooglePlayUrl']" target="_blank">
                                <img :src="require('@/assets/img/google_play.svg')" alt=""/>
                            </a>
                        </div>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="7">
                            <v-btn
                                    block
                                    rounded
                                    depressed
                                    class="btn-azul text-center"
                                    @click="$router.push('/login')"
                            >LETS GET STARTED!
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-spacer></v-spacer>
                </v-col>
            </v-row>
        </div>
    </v-dialog>
</template>

<script>
    export default {
        props: ['show', 'hide'],
        data: () => ({
            image: require("@/assets/logo.svg")
        }),
        components: {},
        methods: {
            close: function () {
                this.hide();
            }
        },
    };
</script>
<style scoped>
    .v-btn--outlined:before, .v-btn--round:before, .v-btn--rounded:before {
        border-radius: inherit;
        width: 30px;
        margin: 2px auto;
        height: 30px;
    }

    .congrats-title {
        font-size: 25px !important;
    }

    .congrats-subtitle {
        font-size: 22px !important;
    }

    @media (max-width: 600px) {
        .congrats-icon {
            display: none;
        }

        .congrats-modal {
            padding: 12px;
        }

        .congrats-row {
            height: auto !important;
            min-height: 0 !important;
        }

        .congrats-title {
            font-size: 20px !important;
        }

        .congrats-subtitle {
            font-size: 18px !important;
        }

        .store-buttons {
            flex-wrap: wrap;
        }

        .store-buttons img {
            max-width: 130px;
        }
    }
</style>
